import React from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import {
  CaAdminMenu,
  SecondaryNavDocustore,
} from "../../../../components/AdminComponents/MenuItems";
import SecondaryNav2 from "../../../../components/AdminComponents/SecondaryNav2";

const DocustoreOrganization = () => {
  return (
    <CaSideNav props={CaAdminMenu}>
      <SecondaryNav2 menuItems={SecondaryNavDocustore} />
      <div className="docustore-form-container-2">
        <div className="group1">
          <div className="form-heading">Docustore - Organization</div>
          <div style={{ padding: "2rem", textAlign: "center" }}>
            <h3>Organization Document Management</h3>
            <p>
              This page will contain organization document management
              functionality.
            </p>
          </div>
        </div>
      </div>
    </CaSideNav>
  );
};

export default DocustoreOrganization;
